module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box invest-with-us"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_c('h1', [_vm._v("Contact us")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    },
    attrs: {
      "id": "contact-form"
    }
  }, [_c('div', {
    staticClass: "container platform contact-us"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 contact-us-left"
  }, [_c('h4', {
    staticClass: "contact-us-title"
  }, [_vm._v("Drop us a line")]), _vm._v(" "), _c('p', {
    staticClass: "contact-us-text"
  }, [_vm._v("Whether you want to learn about our business funding or have questions about business finance in general, our loan specialists are here to help!")]), _vm._v(" "), _c('el-form', {
    ref: "step2Form",
    staticClass: "row",
    attrs: {
      "label-width": '0',
      "model": _vm.step2Form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    staticClass: "col-6 hide-label",
    attrs: {
      "prop": "firstName",
      "label": "First Name",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "First Name*"
    },
    model: {
      value: (_vm.step2Form.firstName),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "firstName", $$v)
      },
      expression: "step2Form.firstName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-6 hide-label",
    attrs: {
      "prop": "lastName",
      "label": "Last Name",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Last Name*"
    },
    model: {
      value: (_vm.step2Form.lastName),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "lastName", $$v)
      },
      expression: "step2Form.lastName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-6 hide-label",
    attrs: {
      "prop": "email",
      "label": "Email",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Email*"
    },
    model: {
      value: (_vm.step2Form.email),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "email", $$v)
      },
      expression: "step2Form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-6 hide-label",
    attrs: {
      "prop": "phone",
      "label": "Phone",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "Phone*"
    },
    model: {
      value: (_vm.step2Form.phone),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "phone", $$v)
      },
      expression: "step2Form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-12 hide-label",
    attrs: {
      "prop": "content",
      "label": "How Can We Help?"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "How Can We Help?"
    },
    model: {
      value: (_vm.step2Form.content),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "content", $$v)
      },
      expression: "step2Form.content"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-button', {
    staticClass: "rounded-pill font-weight-bold",
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "54px",
      "width": "190px",
      "border-radius": "27px",
      "border": "none",
      "margin-top": "36px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Send Message")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Try us now. See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "invest-with-us-main-img",
    attrs: {
      "src": require("../assets/imgs/contact_us_american_credit.png"),
      "alt": "american credit contact us"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 contact-us-right"
  }, [_c('h4', {
    staticClass: "contact-us-title"
  }, [_vm._v("Get in touch with us")]), _vm._v(" "), _c('p', {
    staticClass: "contact-us-text"
  }, [_vm._v("We understand. Sometimes you just want to get a few answers and move on with business.")]), _vm._v(" "), _c('div', {
    staticClass: "row contact-card"
  }, [_c('div', {
    staticClass: "col-1 contact-card-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_location.png"),
      "alt": "american credit location"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 contact-card-text"
  }, [_c('h5', [_vm._v("Address")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("2100 Geng Road, Suite 210"), _c('br'), _vm._v(" Palo Alto, CA 94303")])])]), _vm._v(" "), _c('div', {
    staticClass: "row contact-card"
  }, [_c('div', {
    staticClass: "col-1 contact-card-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_phone.png"),
      "alt": "american credit phone"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 contact-card-text"
  }, [_c('h5', [_vm._v("Phone")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "tel:1855-904-0188"
    }
  }, [_vm._v("855-904-0188")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row contact-card"
  }, [_c('div', {
    staticClass: "col-1 contact-card-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_email.png"),
      "alt": "american credit email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 contact-card-text"
  }, [_c('h5', [_vm._v("Email")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:info@amcredit.com"
    }
  }, [_vm._v("info@amcredit.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfea57f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactUs.vue
// module id = 2018
// module chunks = 5